import React, { useContext, useState, useEffect } from 'react'
import { Form, Modal, ListGroup, Row, Col } from 'react-bootstrap'
import { useSelector, useDispatch } from 'react-redux'
import { useTable } from 'react-table'
import styled from 'styled-components'
import { useMediaQuery } from '@mui/material'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { useTranslate } from '../lib/translate/i18n/useTranslate'
import { AuthContext } from '../context/AuthContext'
import { getURLAPI } from '../utils/getURL'

const Styles = styled.div`
  table {
    border-spacing: 0;
    border: 1px solid black;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      border-right: 1px solid black;

      :last-child {
        border-right: 0;
      }
    }
  }
`

const defaultPropGetter = () => ({})

var columns = []
var data = []

const selectItem = (select, Item) => {
  select(Item)
}

const SelectConfigCloud = ({ field, title, placeholder, value }) => {
  const name = 'cloud'

  const access = useSelector((state) => state.app.access.access)
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  const [modalShow, setModalShow] = React.useState(false)
  const [filter, setFilter] = useState('')
  const translate = useTranslate()
  const auth = useContext(AuthContext)
  const config = auth.config
  let URLAPI = getURLAPI(config)

  let viewtValue = field && field[name] && field[name].name
  if (field && field[name] && field[name].email)
    viewtValue = viewtValue + ' email:' + field[name].email
  if (!isXSmall && field && field[name] && field[name].rootfolder)
    viewtValue = viewtValue + '  папка:' + field[name].rootfolder
  if (
    !isXSmall &&
    field &&
    field[name] &&
    field[name].cloudtype &&
    field[name].cloudtype.name
  )
    viewtValue = viewtValue + ' облако:' + field[name].cloudtype.name
  const ws_client = auth.ws_client

  //  const item_id = body.item_id

  //  const readonly = body.readonly

  const GetData_handle = function (_result) {
    const { tableName, result, readonly, action } = _result
    //console.log('result handle1 ', result)
    dispatch({
      type: 'fetch_current/get',
      payload: result,
      ob: name, //'phone',
    })
  }

  const params = {
    URL_WS: getURLAPI(auth.config, 'URL_WS'), //get address WebSocket BK from config
    auth: { userId: auth.userId, tocken: auth.token },
    handleGetData: GetData_handle,
    //handleChangeData: Refresh_handle,
    //handleSetRefresh: setStartRefresh,
    models: [
      {
        model_call_nm: 'Model_read',
        tableName: 'Clouds',
        action: {
          metod: 'get',
        },
      },
    ],
  }

  //*********** */

  const dispatch = useDispatch()

  useEffect(() => {
    if (modalShow) {
      ws_client.open_process(params)
    }
    //&& dispatch({ type: 'FETCH_LIST', urlapi: URLAPI, ob: name })
  }, [modalShow])

  const select = (Item) => {
    dispatch({
      type: 'app/set',
      payload: {
        id: field,
        field: `${name}id`,
        value: Item,
        ob: name,
      },
      ob: value,
    })

    setModalShow(false)
  }

  const list = useSelector((state) => state.app.current[name]) || []

  let clouds = access && access.user && access.user.clouds && access.user.clouds

  if (filter)
    clouds = clouds.filter((item) => {
      //      console.log('item', item)
      //      console.log('item.name', item.name)
      return (
        (item.name &&
          item.cloud.name.toLowerCase().includes(filter.toLowerCase())) ||
        (item.cloud.email &&
          item.cloud.email.toLowerCase().includes(filter.toLowerCase())) ||
        (item.cloud.rootfolder &&
          item.cloud.rootfolder.toLowerCase().includes(filter.toLowerCase())) ||
        (item.cloud.comments &&
          item.cloud.comments.toLowerCase().includes(filter.toLowerCase())) ||
        (item.cloud.cloudtype.name &&
          item.cloud.cloudtype.name
            .toLowerCase()
            .includes(filter.toLowerCase())) ||
        false
      )
      //[item.name].contains('filter')
    })

  columns = [
    {
      Header: '№',
      accessor: 'num',
    },
    {
      Header: translate('resources.select.fields.name'), //'Имя',
      accessor: 'name',
    },
    {
      Header: 'email',
      accessor: 'email',
    },
    {
      Header: translate('resources.select.fields.rootfolder'), //'Корневая папка ',
      accessor: 'rootfolder',
    },
  ]

  if (!isXSmall) {
    columns.push({
      Header: translate('resources.select.fields.comments'), //'Комент.',
      accessor: 'comments',
    })
    columns.push({
      Header: translate('resources.select.fields.cloudtype'), //'Тип облака',
      accessor: 'cloudtype',
    })
  }
  data = []

  let num = 1
  for (var iw in clouds) {
    if (clouds[iw].cloud)
      data.push({
        num: num++,
        name: clouds[iw].cloud.name,
        cloudtype:
          clouds[iw].cloud.cloudtype && clouds[iw].cloud.cloudtype.name,
        email: clouds[iw].cloud.email,
        rootfolder: clouds[iw].cloud.rootfolder,
        comments: clouds[iw].cloud.comments,
        cloud: clouds[iw].cloud,
      })
  }

  //************************* */
  function Table({
    columns,
    data,
    getHeaderProps = defaultPropGetter,
    getColumnProps = defaultPropGetter,
    getRowProps = defaultPropGetter,
    getCellProps = defaultPropGetter,
  }) {
    // Use the state and functions returned from useTable to build your UI
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
      useTable({
        columns,
        data,
      })

    return (
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  // Return an array of prop objects and react-table will merge them appropriately
                  {...column.getHeaderProps([
                    {
                      className: column.className,
                      style: column.style,
                    },
                    getColumnProps(column),

                    getHeaderProps(column),
                  ])}
                >
                  {column.render('Header')}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row)
            return (
              // Merge user row props in
              <tr {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      // Return an array of prop objects and react-table will merge them appropriately
                      {...cell.getCellProps([
                        {
                          className: cell.column.className,
                          style: cell.column.style,
                        },
                        getColumnProps(cell.column),
                        //  getCellProps(cell),
                      ])}
                      align="center"
                      //                    width="140px"
                    >
                      {(cell.column.id === 'name' && (
                        <Button
                          size="small"
                          color="primary"
                          variant="outlined"
                          sx={{ display: 'inline-flex', alignItems: 'center' }}
                          onClick={(req, res) => {
                            const cloud = cell.row.original.cloud
                            //    console.log(cloud.id)
                            //cell.row.original['worktime_id'],
                            dispatch({
                              type: 'app/set',
                              payload: {
                                id: field,
                                field: `${name}id`,
                                value: cloud,
                                ob: name,
                              },
                              ob: value,
                            })

                            setModalShow(false)
                          }} //onClickCell(cellInfo, req, res),
                          //                        onClick
                        >
                          {cell.render('Cell')}
                        </Button>
                      )) ||
                        cell.render('Cell')}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby={`contained-modal-${name}-vcenter`}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id={`contained-modal-${name}-vcenter`}>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <TextField
            id="outlined-basic"
            label={translate('resources.select.search')} //"Введите поисковый запрос"
            //variant="standard"
            variant="outlined"
            style={{
              marginBottom: 15,
              display: 'flex',
              justifyContent: 'space-between',
            }}
            defaultValue={filter}
            onChange={(item) => setFilter(item.target.value)}
          />
          <Styles>
            <Table
              columns={columns}
              data={data}
              /*          
          getHeaderProps={(column) => ({
            onClick: () => alert('Header!'),
          })}
          getColumnProps={(column) => ({
            onClick: () => alert('Column!'),
          })}
          */
              getRowProps={(row) => ({
                style: {
                  background: row.index % 2 === 0 ? 'rgba(0,0,0,.1)' : 'white',
                },
              })}
              getCellProps={(cellInfo) => ({
                onClick: (req, res) => {
                  console.log(cellInfo)
                }, //onClickCell(cellInfo, req, res),

                /*                style: {
                  backgroundColor: `hsl(${
                    120 * ((120 - cellInfo.value) / 120) * -1 + 120
                  }, 100%, 67%)`,
                },
              */
              })}
            />
          </Styles>
        </Modal.Body>
      </Modal>

      <TextField
        readOnly
        id="outlined-basic"
        label={placeholder}
        //variant="standard"
        variant="outlined"
        style={{
          marginBottom: 15,
          display: 'flex',
          justifyContent: 'space-between',
        }}
        //defaultValue={viewtValue || ''} //field && field[name] && field[name].name}
        value={viewtValue || ''} //field && field[name] && field[name].name}
        onClick={() => setModalShow(true)}
        onFocus={(e) => (e.target.readOnly = true)} //выключение клавиатуры при выборе значения
      />
    </>
  )
}

export default SelectConfigCloud
